import "vue-app/utils/pubSubInitializer";
import { createApp } from "vue";
import PageRegister from "../vue-app-new/pages/PageRegister/PageRegister.vue";
import "./icons";
import TranslatePlugin from "../plugins/edroneTranslate/edroneTranslatePlugin";
import EdroneComponentNamePlugin from "../plugins/edroneComponentName/edroneComponentNamePlugin";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { createRouter, createWebHistory } from "vue-router";
import "../assets/scss/main.scss";
import "../assets/scss/main.css";
import { createPinia } from "pinia";
import { usePostHog } from "vue-app/composables/usePostHog";
import { VueQueryPlugin } from "@tanstack/vue-query";

if (document.querySelector("#register")) {
  const router = createRouter({
    history: createWebHistory("/register/"),
    routes: [
      {
        path: "/:pathMatch(.*)*",
        name: "register",
      },
    ],
  });
  usePostHog();
  const app = createApp(PageRegister);
  const pinia = createPinia();
  app.use(router);
  app.use(pinia);
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 2,
          retryDelay: 3000,
          staleTime: 1000 * 60,
        },
      },
    },
  });
  app.component("font-awesome-icon", FontAwesomeIcon);
  app.use(TranslatePlugin);
  app.use(EdroneComponentNamePlugin);
  app.mount("#register");
}
